<p-toast key="tk" position="top-right"></p-toast>
<div class="geolocalizacion-container w-100 h-100 background-image">
    <div class="gral-container">
        <div class="logo-container">
            <img src="assets/images/icons/monex_login_icon.svg" alt="monex-icon"><br>
        </div>
        <div class="line-container">
            <hr class="vr-line">
        </div>

        <div *ngIf="!validatingRedirect" class="father-container">
            <div class="geolocalizacion-content" [ngClass]="{'d-none' : showAuth07Error}">
                <div *ngIf="showInit" class="content-container tips-container w-100">
                    <div class="tips-background">
                        <span class="sub-title">
                            {{ 'Tips de Seguridad'|translate }}
                        </span>
                        <div class="items-list">
                            <ul>
                                <li>
                                    No te solicitaremos datos confidenciales a través de ningún medio electrónico, tales
                                    como NIP o Claves de
                                    Acceso u operación. Así mismo, no debes proporcionarlas por ningún motivo a
                                    terceros:
                                    <a style="text-decoration: none; color: '#fff';"
                                       href="https://www.monex.com.mx/portal/banca-de-empresas/81/consejos-de-seguridad">
                                        https://www.monex.com.mx/portal/banca-de-empresas/81/consejos-de-seguridad
                                    </a>
                                </li>
                                <li>
                                    Para evitar el phishing (correos electrónicos aparentemente confiables que solicitan
                                    datos confidenciales de
                                    tus cuentas), no contestes ningún correo que solicite información personal y
                                    verifica el
                                    origen de la
                                    solicitud con tu Asesor Monex
                                </li>
                                <li>
                                    Asegúrate que la dirección del sitio de Internet de Monex sea:
                                    <a style="text-decoration: none; color: '#fff';"
                                       href="https://www.monex.com.mx">https://www.monex.com.mx</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <button type="button" class="btn btn-banca-digital" (click)="changeShow($event)">
                        <span>{{ 'Ir a Banca Digital' | translate }}</span>
                    </button>
                </div>
                <div *ngIf="showGeolocalization && !showInit" class="content-container w-100">
                    <div class="w-100">
                        <span class="sub-title-geo">
                            <img src="assets/images/icons/geolocalizacion_icon.svg" alt="geolocalizacion_icon">
                            {{ 'GEOLOCALIZACIÓN'|translate }}
                        </span>
                    </div>
                    <div class="w-100">
                        <p class="geo-description">{{ 'Debes aceptar el uso de geolocalización para el uso de la Banca Digital'|translate }}</p>
                    </div>
                    <div class="w-100">
                        <button type="button" class="btn-primary btn btn-banca-digital" (click)="validateGeo()"
                                [disabled]="loadingLocation">
                            <span *ngIf="loadingLocation" class="spinner-border spinner-border-sm" role="status"
                                  aria-hidden="true"></span>
                            <span>{{ 'Permitir geolocalización' | translate }}</span>
                        </button>
                    </div>
                </div>

                <div *ngIf="this.showLogin && !showInit && !this.showValidateToken" class="login-form-container">
                    <lib-login (onAuth07Error)="onAuth07Error($event)"
                               (onLoginSuccess)="loginSuccess($event)"></lib-login>
                </div>

                <div *ngIf="this.showValidateToken && !showInit" class="validate-token-form-container">
                    <lib-login-token (onValidateTokenSuccess)="validateTokenSuccess()"></lib-login-token>
                </div>
                <div *ngIf="!attemptsAllowed && !showInit && !showAuth07Error" class="security-tips-container"
                     (click)="changeShow($event)">
                    <img src="assets/images/icons/security-tips-icon.svg" alt="monex">
                    <p class="tips-label">{{ 'Tips de seguridad'|translate }}</p>
                </div>
            </div>
            <div class="attempts-allowed-container" *ngIf="attemptsAllowed">
                <div class="content">
                    <div class="box-container">
                        <div class="box">
                            <img src="assets/images/warning.png" class="monex">
                            {{ 'Superaste el numero de intentos permitidos'|translate }}
                        </div>
                    </div>
                    <div class="paragraph">
                        <p>
                            {{ 'Por seguridad'|translate }}, <span
                                class="blue-label">{{ 'deshabilitamos tus accesos'|translate }}s</span>
                        </p>
                    </div>
                    <div class="paragraph">
                        <p>
                            {{ 'Para recuperar tus accesos'|translate }},
                            <span class="blue-label">gac@monex.com.mx</span> {{ 'con los siguientes datos'|translate }}:
                        </p>
                    </div>
                    <div class="paragraph">
                        <p>{{ 'Asunto'|translate }}: {{ 'Contraseña temporal'|translate }}</p>
                        <ul>
                            <li>{{ 'Numero de contrato'|translate }}</li>
                            <li>{{ 'Nombre completo del Titular del contrato'|translate }}</li>
                            <li>{{ 'Nombre completo del Participante del contrato'|translate }}</li>
                        </ul>
                    </div>
                    <div class="btn-container">
                        <button class="btn btn-primary">{{ 'Ir a Banca digital'|translate }}</button>
                    </div>
                </div>
            </div>
            <div class="attempts-allowed-container" *ngIf="showAuth07Error">

                <div class="box-container">
                    <div class="box-active-session">
                        <ng-container *ngIf="!showWebAlreadySession; else showWebText">
                            <div>
                                <span>{{ 'ACTIVE_SESSION_SPAN'|translate }}</span>. {{
                                    'ACTIVE_SESSION_PARAGRAPH'|translate
                                }}
                            </div>
                        </ng-container>
                        <ng-template #showWebText>
                            <div>
                                <span>{{ 'ACTIVE_SESSION_SPAN_WEB' | translate }}</span>. {{
                                    'ACTIVE_SESSION_PARAGRAPH'|translate
                                }}
                            </div>
                        </ng-template>
                    </div>
                </div>
                <div class="close-session-buttons mt-4 mb-4">
                    <button class="btn btn-primary" (click)="redirectToLogin()">{{ 'intentar nuevamente'|translate }}
                    </button>
                    <button class="btn btn-primary" (click)="sendEmailToCloseSession()"
                            [disabled]="loadingSendingEmail">
                        <ng-container *ngIf="!loadingSendingEmail; else loadingCloseSession">
                            {{ 'Cerrar sesion'|translate }}
                        </ng-container>
                        <ng-template #loadingCloseSession>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            {{ 'Validando'|translate }}...
                        </ng-template>
                    </button>
                </div>
                <div class="security-tips-container d-flex" (click)="changeShow($event)">
                    <img src="assets/images/icons/security-tips-icon.svg" alt="monex">
                    <p class="tips-label mx-1">{{ 'Tips de seguridad'|translate }}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="progressSpinner" *ngIf="validatingRedirect">
        <p-progressSpinner></p-progressSpinner>
    </div>
</div>
